import {
  Autocomplete as RACAutocomplete,
  type AutocompleteProps as RACAutocompleteProps,
  Input as RACInput,
  type InputProps as RACInputProps,
  SearchField as RACSearchField,
  type SearchFieldProps as RACSearchFieldProps,
} from "react-aria-components";

export interface AutocompleteProps<T extends object> extends RACAutocompleteProps<T> {}
export interface SearchFieldProps extends RACSearchFieldProps {}
export interface SearchFieldInputProps extends RACInputProps {}

export function Autocomplete<T extends object>(props: AutocompleteProps<T>) {
  return <RACAutocomplete {...props} />;
}

export function SearchField(props: SearchFieldProps) {
  return <RACSearchField {...props} />;
}

export function SearchFieldInput(props: SearchFieldInputProps) {
  return <RACInput {...props} />;
}
